var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('app-icon',{attrs:{"icon":_vm.icon,"color":_vm.fontColor},on:{"click":function($event){return _vm.$emit('click')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }